import { coreAxios } from "utilities/axios";
import { createAsyncThunk } from "@reduxjs/toolkit";

const BASE_URL = process.env.REACT_APP_MAIN_URL

export const UpdateStock = createAsyncThunk(
  "stock/UpdateStock",
  async (data) => {
    const response = await coreAxios.put(`${BASE_URL}/api/stock/update/${data.id}/`, data)
    return response.data
  }
);

export const GetStocks = createAsyncThunk(
  "stock/GetStocks",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/stock/list/`);
    return data
  }
);

export const GetStocksForSale = createAsyncThunk(
  "stock/GetStocksForSale",
  async () => {
    const {data} = await coreAxios.get(`${BASE_URL}/api/stock/for/sale/list/`);
    return data
  }
);

